import {
  PhoneIcon,
  UrgentLowSMSIcon,
} from "@tandemdiabetes/sugarmate-react-components"
import type {
  FunctionComponent,
  SVGProps,
} from "react"
import { useMemo } from "react"

import styles from "./AlertsIndex.module.scss"
import {
  PageLink,
  PageTemplate,
} from "src/components"
import {
  useFollowedUsers,
  usePolyglot,
} from "src/contexts"

export function AlertsIndex() {
  const {
    currentFollow,
    currentUserId,
  } = useFollowedUsers()

  const polyglot = usePolyglot()

  const pages = useMemo(
    () => [
      {
        routePath: currentFollow.is_self ? "/settings/alerts/sms" as const : "/settings/alerts/sms/$accountId" as const,
        params: currentFollow.is_self ? {} : { accountId: currentUserId },
        polyglotPhraseKey: "pages.alerts.pages.sms",
        Icon: UrgentLowSMSIcon as FunctionComponent<SVGProps<SVGElement>>,
        id: "SMS",
      },
      {
        routePath: currentFollow.is_self ? "/settings/alerts/phone_call" as const : "/settings/alerts/phone_call/$accountId" as const,
        params: currentFollow.is_self ? {} : { accountId: currentUserId },
        polyglotPhraseKey: "pages.alerts.pages.phone_call",
        Icon: PhoneIcon as FunctionComponent<SVGProps<SVGElement>>,
        id: "Phone",
      },
    ],
    [
      currentFollow,
      currentUserId,
    ],
  )

  return (
    <PageTemplate
      user="follow"
      title={polyglot.t("components.page_header.pages.alerts")}
      backRoutePath={currentFollow.is_self ? "/settings" as const : "/settings/$accountId" as const}
      backRouteParams={currentFollow.is_self ? {} : { accountId: currentUserId }}
    >
      <div className={styles.container}>
        {pages.map(
          (pageLinkProps) => (
            <PageLink
              key={pageLinkProps.routePath}
              {...pageLinkProps}
            />
          ),
        )}
      </div>
    </PageTemplate>
  )
}
